import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PkService } from './pk.service';
import { UIRouterModule } from '@uirouter/angular';
import { PkStates } from './pk-states';
import { PkEditContainerComponent } from './pk-edit-container/pk-edit-container.component';
import { FiButtonBackNewModule } from '../../shared/fi-button-back-new/fi-button-back-new.module';
import { FiAppTextSharedModule } from '../../shared/app-text';
import { FiTabsModule } from '../../utilities/tabs/tabs.module';
import { PkSettingsComponent } from './pk-settings/pk-settings.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { PkUnitsMatchingComponent } from './pk-units-matching/pk-units-matching.component';
import { MatSelectModule } from '@angular/material/select';
import { PkRolesMatchingComponent } from './pk-roles-matching/pk-roles-matching.component';
import { PkUsersMatchingComponent } from './pk-users-matching/pk-users-matching.component';
import { PkUserImportComponent } from './pk-user-import/pk-user-import.component';
import { PkImportLogComponent } from './pk-import-log/pk-import-log.component';
import { MatCardModule } from '@angular/material/card';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { FiPrintDownloadModule } from '../../shared/fi-print-download/fi-print-download.module';
import { FiProfileIconModule } from '../../shared/profile-icon/profile-icon.module';
import { FiWrapperTableModule } from '../../shared/fi-wrapper-table/fi-wrapper-table.module';
import { FiFormatDateModule } from '../../shared/fi-format-date/fi-format-date.module';
import { MatTableModule } from '@angular/material/table';
import { PkImportLogDetailedDialogComponent } from './pk-import-log/pk-import-log-detailed-dialog/pk-import-log-detailed-dialog.component';
import { PkLogContainerComponent } from './pk-log-container/pk-log-container.component';
import { FiPkUsersMatchingDialogComponent } from './pk-users-matching/fi-pk-users-matching-dialog/fi-pk-users-matching-dialog.component';
import { FiPkUsersMatchingTableComponent } from './pk-users-matching/fi-pk-users-matching-table/fi-pk-users-matching-table.component';
import { FiPkUserMatchDialogComponent } from './pk-users-matching/fi-pk-user-match-dialog/fi-pk-user-match-dialog.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { SelectSearchModule } from '../../shared/fi-select-search/select-search.module';
import { MatSortModule } from '@angular/material/sort';
import { FiWhenScrolledModule } from '../../shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FiIconTooltipButtonModule } from '@fi-shared/fi-icon-tooltip-button/fi-icon-tooltip-button.module';
import { MatRadioModule } from '@angular/material/radio';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { PkHelperService } from '@fi-app/external-platform-integration/pk/pk-helper.service';

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild(PkStates),
        MatSlideToggleModule,
        MatSelectModule,
        MatCardModule,
        MatButtonModule,
        FormsModule,
        FiButtonBackNewModule,
        FiAppTextSharedModule,
        FiTabsModule,
        FiPrintDownloadModule,
        FiProfileIconModule,
        FiWrapperTableModule,
        FiFormatDateModule,
        MatTableModule,
        MatAutocompleteModule,
        MatInputModule,
        SelectSearchModule,
        MatSortModule,
        FiWhenScrolledModule,
        FiValidatingFormModule,
        MatCheckboxModule,
        FiIconTooltipButtonModule,
        MatRadioModule,
        MatExpansionModule,
        MatIconModule,
    ],
    declarations: [
        PkEditContainerComponent,
        PkSettingsComponent,
        PkUnitsMatchingComponent,
        PkRolesMatchingComponent,
        PkUsersMatchingComponent,
        PkUserImportComponent,
        PkImportLogComponent,
        PkImportLogDetailedDialogComponent,
        PkLogContainerComponent,
        FiPkUsersMatchingDialogComponent,
        FiPkUsersMatchingTableComponent,
        FiPkUserMatchDialogComponent,
    ],
    providers: [PkService, PkHelperService],
})
export class PkModule {}
